import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import Addfiles from "../../common/Addfiles";
            

export function invoiceStep2Review(props) {

const [response, setResponse] = useState(null);
const [notes, setNotes] = useState(null);
const [disabledButton, setDisabledButton] = useState(true);
const invoice = useSelector( (state) => state.invoices.invoice );
const currentUser = useSelector( (state) => state.auth.user );

useEffect(() => {
    if (response === "approved" || response === "rejected") {
        disabledButton && setDisabledButton(false);
    }
}, [response])

const handleChangeValue = (e) => {
    setResponse(e.target.value);
}
const handleAddNotes = (e) => {
    setNotes(e.target.value);
}

const handleSubmit = (e) => {
    e.preventDefault();
    const approval = response === "approved" ? true : false
    const invoiceUpdates = { approval_level: invoice.party_responsible[0].level, response: approval, notes: notes}
    // no: if multiple approvals, until confirmed, say "Approved by ${user}"
    const vendorName = invoice.company_vendor.name ? invoice.company_vendor.name : "the Vendor"
    const message = response === "approved" 
        // currentusere is !APP1 "user notified of rejection" : rejection and notes sent to...
        ? `Approved by ${currentUser.first_name} ${currentUser.last_name}` 
        : ( invoice.party_responsible[0].level !== 1 ? "Previous Approver notified of rejection" : `Rejection and notes sent to ${vendorName}.`)
    props.handleResponseSubmit(invoiceUpdates, message);
}

    return (
        <form onSubmit={(e) => handleSubmit(e)} className="gap-above-m gap-below-s">
            <div className={response === "approved" ? "typical-radio checked" : "typical-radio"} >
                <label className="content2" htmlFor="approved">
                    <input type="radio" id="approved" name="approval" value={"approved"} onChange={(e) => handleChangeValue(e)} checked={response === "approved"}/>
                    Approved
                </label>
            </div>
            <div className={response === "rejected" ? "typical-radio checked gap-below-xs" : "typical-radio gap-below-xs"} >
                <input type="radio" id="rejected" name="approval" value={"rejected"} onChange={(e) => handleChangeValue(e)} checked={response === "rejected"}/>
                <label className="content2" htmlFor="rejected">Rejected</label>
            </div>
            <div className="gap-above-s gap-below-s">
                <p className="content2 heavy-grey gap-below-xs">Supporting Documents</p>
                <Addfiles 
                    uploadTitle="+ Add Supporting Docs"
                    selectedFiles={props.selectedFilesAdditional}
                    handleDrop={props.handleDrop}
                    removeSelectedFile={props.removeSelectedFile}

                    maxSize={10485760}
                    maxFiles={0}
                    multiple={true}
                    accept=""
                />
            </div>
            <div className="inputs-wrapper" >
                <div className="input-basic textarea addspace">	
                    { response === "rejected"
                    ? <label className="textarea" htmlFor="notes">Reason for Rejection <span>*</span></label>
                    : <label className="textarea" htmlFor="notes">Notes (optional)</label>
                    }									
                    <textarea type="text" name="notes" id="notes" required={response === "rejected"} minLength={response === "rejected" ? "10" : "0"} rows="3" onChange={(e) => handleAddNotes(e)}/>
                </div>
            </div>
            <div className="gap-above-s">
                <button id="invoice_confirm" className="btn pri min-width" type="submit" disabled={disabledButton || props.isSubmitting} >{props.isSubmitting ? "Please wait..." : "Confirm"}</button>
            </div>
        </form> 
    )
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(invoiceStep2Review);
// export default connect(mapStateToProps, {createInvoice, deleteInvoiceDraft})(Invoices);